import React from 'react';

interface PaginationProps {
  isLoading: boolean;
  isPaginationLoading: boolean;
  nextCursor: string | null;
  onLoadMore: () => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  isLoading,
  isPaginationLoading,
  nextCursor,
  onLoadMore,
}) => {
  return (
    <div className="flex justify-center mt-6 mb-2">
      <button
        onClick={onLoadMore}
        disabled={isLoading || isPaginationLoading || nextCursor === null}
        className={`w-full max-w-xs py-3 rounded-md font-sans font-medium tracking-wide uppercase text-xs border transition-all flex items-center justify-center gap-2
          ${(isLoading || isPaginationLoading || nextCursor === null) 
            ? 'bg-cat-sidebar text-cat-text-dark border-cat-border cursor-not-allowed opacity-50' 
            : 'bg-cat-border text-cat-text-main border-cat-text-dark hover:border-cat-accent hover:text-cat-accent'
          }`}
      >
        {isPaginationLoading ? (
          <>
            <svg className="animate-spin h-4 w-4 text-cat-text-main" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>Loading live events...</span>
          </>
        ) : (
          nextCursor === null ? 'No More Events' : 'Load More Events'
        )}
      </button>
    </div>
  );
};